import api from './client'

export interface Ticket {
  id: string
  ticket_number: number
  category: string
  service: string | null
  subject: string | null
  status: string
  priority: string
  created_at: string
  updated_at: string
  closed_at: string | null
  last_message: string | null
  message_count: number
}

export interface Attachment {
  id: string
  filename: string
  content_type: string
  size_bytes: number
  url: string
}

export interface Message {
  id: string
  sender_type: string
  message: string
  created_at: string
  attachments: Attachment[]
}

export interface TicketDetail {
  id: string
  ticket_number: number
  category: string
  service: string | null
  subject: string | null
  status: string
  priority: string
  created_at: string
  updated_at: string
  closed_at: string | null
  messages: Message[]
}

export async function listTickets(status?: string): Promise<{ tickets: Ticket[]; total: number }> {
  const params = status ? `?status=${status}` : ''
  return api.request(`/api/v1/support/tickets${params}`)
}

export async function getTicket(id: string): Promise<TicketDetail> {
  return api.request(`/api/v1/support/tickets/${id}`)
}

export async function createTicket(data: {
  category: string
  service?: string
  subject?: string
  message: string
  priority?: string
}): Promise<TicketDetail> {
  return api.request('/api/v1/support/tickets', { method: 'POST', body: data })
}

export async function sendMessage(ticketId: string, message: string): Promise<Message> {
  return api.request(`/api/v1/support/tickets/${ticketId}/messages`, {
    method: 'POST',
    body: { message },
  })
}

export async function reopenTicket(ticketId: string): Promise<{ ok: boolean }> {
  return api.request(`/api/v1/support/tickets/${ticketId}/reopen`, { method: 'POST' })
}

export async function uploadAttachment(ticketId: string, file: File, messageId?: string): Promise<{
  ok: boolean
  id: string
  filename: string
  url: string
  size_bytes: number
}> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('ticket_id', ticketId)
  if (messageId) formData.append('message_id', messageId)

  const token = localStorage.getItem('token')
  const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8100' : '')

  const resp = await fetch(`${API_URL}/api/v1/support/upload`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  })

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({ detail: 'Ошибка загрузки' }))
    throw new Error(err.detail || 'Ошибка загрузки')
  }

  return resp.json()
}